export { FavoritesTab } from "./favoritesTabs.ui";
export { useFavoritesTabScript } from "./favoritesTabs.script";
export { FavoritesTabWidget } from "./favoritesTabs.widget";
